import GoogleMapReact from 'google-map-react';

import React from 'react';

const Map = () => {
  const defaultProps = {
    center: {
      lat: 23.68,
      lng: 90.35
    },
    zoom: 11,
  };
  return (
    <div style={{ height: '60vh', width: '80vh', borderRadius: '10px', overflow: 'hidden'}}>
       <GoogleMapReact
          bootstrapURLKeys={{ key: 'AIzaSyB0KhIhMG80sVMK34ds_ovqan4sVm3AEK0'}}
          defaultCenter={defaultProps.center}
          defaultZoom={defaultProps.zoom}
        ></GoogleMapReact>
    </div>
  );
};

export default Map;